import { gql } from "graphql-request";
import { useState } from "react";
import { gqlClient } from "../configs/api-config";
import { formatAndRaiseError } from "../helpers/general";

export function useFreeLogistic() {
  let [loadingFreeLogistic, setLoadingFreeLogistic] = useState(false);
  function freeLogisticPrice(orderId, status) {
    setLoadingFreeLogistic(true);

    return gqlClient
      .request(
        gql`
          mutation proxyUpdateInPersonStatus(
            $orderId: Int!
            $status: Boolean!
          ) {
            proxyUpdateInPersonStatus(orderId: $orderId, status: $status) {
              orderId
              status
            }
          }
        `,
        {
          orderId: Number(orderId),
          status: status,
        }
      )
      .catch(formatAndRaiseError)
      .finally(() => {
        setLoadingFreeLogistic(false);
      });
  }

  return { freeLogisticPrice, loadingFreeLogistic };
}
